import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';
import { styled } from '@mui/system';

export interface TabProps extends MuiTabProps {
  tabsId?: string;
  isVisible?: boolean;
}

export const Tab = styled(
  ({ tabsId, isVisible = true, ...props }: TabProps) => {
    const muiTabProps  = {
      sx: {
        display: isVisible ? 'inline-flex' : 'none',
        backgroundColor: 'common.white'
      },
      ...props,
      ...(tabsId ? a11yProps(tabsId, props.value) : {})
    };

    return <MuiTab {...muiTabProps} />;
  }
)({});

function a11yProps(tabsId: string, value: string) {
  return {
    id: `${tabsId}-tab-${value}`,
    'aria-controls': `${tabsId}-tabpanel-${value}`
  };
}
